// @ts-check
import * as Services from 'shared/services';

export default Services;
